import type {ICustomer} from "@mytour/shared";
import {getLabel} from "@mytour/shared";
import {Alert} from "reactstrap";

type Props = {
  customer?: ICustomer;
};
export function NoCustomerNotification({customer}: Props) {
  if (!customer) {
    return null;
  }
  return (
    <Alert color="danger">
      {`Il sera impossible d'envoyer une notification.`}
      <br />
      {getLabel(customer)}
      <b>{` n'a aucun email`}</b>
      {" renseigné."}
    </Alert>
  );
}
